// Figür öncüllerden ÖNCE (GRAFIK_EKSEN_STANDARDI v2.0 §14, KURALLAR §4.21.1 v1.39 —
// Mehmet kararı 2026-09-26). Gövdeyi figürün üstünde ve altında kalacak iki parçaya böler.
//
// İKİZ: backend/src/services/pdfExport.js `_figurOnculBol` — aynı kural basımda uygulanır.
// Kilit: tests/test_figur_oncul_bol.js (iki tarafı aynı örneklerle koşturur).
//
// Bölme noktası: ilk `I.` / `I)` satırı ya da madde imi (`•`, `$\bullet$`). Hemen
// üstündeki boş olmayan satır AÇIŞ ise (yalnız `\textbf{...}`, noktalama ile bitmiyor —
// §4.21.1 bölünmüş kapanışın açışı) ya da `:` ile bitiyorsa o da figürün altına iner.
// Satırın SON cümlesi listeyi tanıtıyorsa ("Hakem bu turla ilgili üç ifade
// değerlendirmektedir." — eski Biçim B, 2026-09-27) o cümle de iner.
// Güvenli düşüş (null): üst parça boş / bölme açık `{` ya da `$` içinde.

const BOLME_BASI = /^\s*(?:I\s*[.)]\s|•\s|\$\\bullet\$\s)/;
const ACIS_SATIRI = /^\s*\\textbf\{[^{}]*[^.?!:;,\s{}]\s*\}\s*(?:\\\\)?\s*$/;
const YUKARI_ATIF = /yukar[ıi]da(?:ki)?\s+(?:\S+\s+){0,3}?(?:grafi|şekil|sekil|tablo|çizil|cizil|gösteril|gosteril|verilmi|diyagram)/i;
const GIRIS_CUMLESI = /(?:^|\s)(?:iki|üç|uc|dört|dort|beş|bes|bazı|bazi|birkaç|birkac|aşağıdaki|asagidaki)\s+(?:\S+\s+)?(?:ifade|yargı|yargi|öncül|oncul|bilgi|görüş|gorus|çıkarım|cikarim|tespit|iddia)\S*\s+(?:\S+\s+){0,2}?\S+\.\s*(?:\\\\)?\s*$/i;

function denge(metin) {
  let derinlik = 0;
  let dolar = 0;
  for (let i = 0; i < metin.length; i++) {
    if (metin[i] === '\\') { i++; continue; }
    if (metin[i] === '{') derinlik++;
    else if (metin[i] === '}') derinlik--;
    else if (metin[i] === '$') dolar++;
  }
  return { derinlik, tekDolar: dolar % 2 === 1 };
}

export function figurOnculBol(govde) {
  if (typeof govde !== 'string' || !govde) return null;
  const satirlar = govde.split('\n');
  let bol = satirlar.findIndex((s) => BOLME_BASI.test(s));
  if (bol <= 0) return null;
  let j = bol - 1;
  while (j >= 0 && !satirlar[j].trim()) j--;
  if (j >= 0 && (ACIS_SATIRI.test(satirlar[j]) || /:\s*(?:\\\\)?\s*$/.test(satirlar[j]))) bol = j;
  else if (j >= 0) {
    const cumleler = satirlar[j].split(/(?<=[.!?])\s+(?=\S)/);
    if (GIRIS_CUMLESI.test(cumleler[cumleler.length - 1])) {
      if (cumleler.length === 1) bol = j;
      else {
        const son = cumleler.pop();
        satirlar.splice(j, 1, cumleler.join(' '), son);
        bol = j + 1;
      }
    }
  }
  // Figüre "yukarıda … gösterilmiş/çizilmiş" diye atıf yapan paragraf figürün ALTINDA
  // doğrudur (§14) — hemen üstteyse o da iner.
  let k = bol - 1;
  while (k >= 0 && !satirlar[k].trim()) k--;
  if (k > 0 && YUKARI_ATIF.test(satirlar[k])) bol = k;
  const ust = satirlar.slice(0, bol).join('\n');
  const alt = satirlar.slice(bol).join('\n');
  if (!ust.trim() || !alt.trim()) return null;
  const d = denge(ust);
  if (d.derinlik !== 0 || d.tekDolar) return null;
  return { ust: ust.replace(/\s+$/, ''), alt: alt.replace(/^\s+/, '') };
}

// Kartta gövde yerleşimi: üst → görsel → alt (öncüller) → kapanış. Öğretmen kartı (SoruKarti) ve
// müşteri kartı (MusteriSoruKarti) aynı bölmeyi kullanır — figür iki panelde aynı yerde basılır.
// Kapanış: \textbf{Buna göre,...} VEYA düz satır-başı "Buna göre,.../Bu durumda,.../Verilenlere göre,..."
const KAPANIS_RE = /(?:\\textbf\s*\{\s*|(?:^|\n)[ \t]*)(?:Buna\s+g[oö]re|Bu\s+durumda|Verilenlere\s+g[oö]re)[^]*$/i;

export function govdeYerlesim(metin, gorselVar) {
  const km = KAPANIS_RE.exec(metin);
  let kapanis = km ? km[0].replace(/^\s+/, '') : '';
  let giris = km ? metin.slice(0, km.index).trimEnd() : metin;
  // İBARE-DIŞI KAPANIŞ (2026-08-11): ÖSYM kapanışları her zaman
  // "Buna göre/Bu durumda/Verilenlere göre" ile başlamaz —
  // "Bu tabloya göre…", "Bu gözlemlere göre…", "Bu ürünlere göre…",
  // "Aşağıdaki eşleştirmelerden hangisi…" de geçerli kapanıştır
  // (85 tablolu soruda 19'u bu biçimde). İbare listesi genişletmek
  // yerine YAPISAL ölçüt: metnin EN SONUNDAKİ kalın blok bir SORU
  // cümlesiyse kapanıştır. Blok sonda değilse (öncüllerden önce
  // geliyorsa) dokunulmaz — öncüller kapanışın içine yutulmasın.
  if (!km) {
    const bas = metin.lastIndexOf('\\textbf{');
    if (bas !== -1) {
      let derinlik = 1, j = bas + 8;
      while (j < metin.length && derinlik > 0) {
        if (metin[j] === '{') derinlik++;
        else if (metin[j] === '}') derinlik--;
        j++;
      }
      const ic = metin.slice(bas + 8, j - 1);
      if (derinlik === 0 && metin.slice(j).trim() === '' && /\?\s*$/.test(ic)) {
        kapanis = metin.slice(bas).trim();
        giris = metin.slice(0, bas).trimEnd();
      }
    }
  }
  // ÖNCÜL bloğu (I. ... ya da • maddeleri) grafikten SONRA — öğretmen talimatı
  // 2026-07-14 (#13866) + GRAFIK_EKSEN_STANDARDI v2.0 §14 (2026-09-26): bağlam →
  // görsel → (açış / ":" giriş cümlesi) → öncüller. Grafik yoksa öncüller ayrılmaz.
  const bolme = gorselVar ? figurOnculBol(giris) : null;
  return bolme ? { ust: bolme.ust, alt: bolme.alt, kapanis } : { ust: giris, alt: '', kapanis };
}
